import { cn } from '@/lib/utils'

export interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  as?: 'section' | 'div' | 'article'
  background?: 'white' | 'light' | 'dark' | 'accent' | 'slate'
  container?: boolean
  title?: string
  subtitle?: string
  titleAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  textCenter?: boolean
}

export function Section({
  children,
  as: Component = 'section',
  background = 'white',
  container = true,
  title,
  subtitle,
  titleAs: TitleComponent = 'h2',
  textCenter = false,
  className,
  ...props
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    light: 'bg-[#e6e7ea]',
    dark: 'bg-gray-900 text-white',
    accent: 'bg-[#f75e47] text-white',
    slate: 'bg-slate-50',
  }

  return (
    <Component
      className={cn('py-16 md:py-24', backgrounds[background], className)}
      {...props}
    >
      <div className={cn(container && 'mx-auto max-w-7xl px-4 lg:px-8')}>
        {(title || subtitle) && (
          <div className={cn('mb-10 md:mb-14', textCenter && 'text-center')}>
            {title && (
              <TitleComponent className={cn('text-3xl font-bold tracking-tight md:text-4xl', textCenter && 'mx-auto')}>
                {title}
              </TitleComponent>
            )}
            {subtitle && (
              <p className={cn('mt-3 max-w-[768px] text-lg text-current/80', textCenter && 'mx-auto')}>{subtitle}</p>
            )}
          </div>
        )}
        {children}
      </div>
    </Component>
  )
}
